var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('nav',{staticClass:"recruit_nav"},[_c('ul',_vm._l((_vm.navs),function(nav,index){return _c('li',{key:index,class:{'active': nav.active}},[(nav.isChild)?_c('router-link',{attrs:{"to":nav.name}},[_vm._v(_vm._s(nav.title))]):_vm._e()],1)}),0)]),_c('div',{staticClass:"recruit_main"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }